export default __webpack_public_path__ + "static/media/coach_guideme_lancingkit_lancets100_strips100_white@2x.a121479a.webp";